// extracted by mini-css-extract-plugin
var _1 = "NotFound_collapsed__kmKuh";
var _2 = "NotFound_message__oXpbZ";
var _3 = "NotFound_messageCloseButton__4HsaH";
var _4 = "NotFound_messageCloseIcon__YVmDN";
var _5 = "NotFound_messageCollapsed__3mVHm";
var _6 = "NotFound_messageContent__5gmY4";
var _7 = "NotFound_messageHeader__6QMV3";
var _8 = "NotFound_messageIcon__K9ib-";
var _9 = "NotFound_messageIconCollapsed__8tmur";
var _a = "NotFound_messageTitle__+E+AR";
var _b = "NotFound_nfFadeIn__r5jBD";
var _c = "NotFound_nfSlideIn__eCRgF";
var _d = "NotFound_text__duXat";
export { _1 as "collapsed", _2 as "message", _3 as "messageCloseButton", _4 as "messageCloseIcon", _5 as "messageCollapsed", _6 as "messageContent", _7 as "messageHeader", _8 as "messageIcon", _9 as "messageIconCollapsed", _a as "messageTitle", _b as "nfFadeIn", _c as "nfSlideIn", _d as "text" }
